import { BuildingDTO } from "./building";
import { FileLog } from "./file";

export enum BuildingVolumePermitStatus {
    OK = 'Gebouw volume vergund',
    PARTIAL = 'Gebouw volume gedeeltelijk vergund',
    NOT_REQUIRED = 'Gebouw vergund geacht',
    NOT_OK = 'Gebouw volume niet vergund',
    UNKNOWN = "Nog na te kijken"
}

export enum UnitsPermittedStatus {
    OK = 'Alle units vergund',
    PARTIAL = 'Units gedeeltelijk vergund',
    NOT_REQUIRED = 'Units vergund geacht',
    UNKNOWN = "Nog na te kijken"
}

export enum RiskActivities {
    RISK_SOIL = 'Risicogrond, heden risico-activiteiten',
    RISK_SOIL_PAST = 'Risicogrond, vroeger risico-activiteiten',
    NO_RISK_SOIL = 'Geen risicogrond',
    NO_INFORMATION = 'Geen aanwijzingen van risico-activiteiten',
    UNKNOWN = "Nog na te kijken"
}

export enum SoilStatus {
    REMEDIATION_REQUIRED_THIRD_PARTY = 'Vervuiling, door naburig perceel',
    REMEDIATION_REQUIRED_OWN = 'Vervuiling, eigen perceel',
    NO_POLLUTION = 'Geen vervuiling aanwezig',
    NO_INFORMATION = 'Geen aanwijzingen van vervuiling',
    UNKNOWN = "Nog na te kijken"
}

export enum PScore {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    UNKNOWN = "Nog na te kijken"
}

export enum GScore {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    UNKNOWN = "Nog na te kijken"
}

export type PermitDTO = {
    id: number;
    summary: string;
    buildingRegulatoryInfo: BuildingRegulatoryInfoDTO;
    fileLogId: number;
    fileLog: FileLog;
}

export type BuildingRegulatoryInfoDTO = {
    id: number;
    building: BuildingDTO;
    permits: PermitDTO[];
    buildingVolumePermitted: BuildingVolumePermitStatus;
    buildingPermitRemarks: string;
    unitsPermitted: UnitsPermittedStatus;
    unitPermitRemarks: string;
    numUnitsPresent: number;
    numUnitsPermitted: number;
    soilStatus: SoilStatus;
    soilStatusRemarks: string;
    soilActivities: RiskActivities;
    soilCertificateFileLogId: number;
    soilCertificateFileLog: FileLog;
    pScore: PScore;
    gScore: GScore;
    urbanExtractFileLogId: number;
    cadastralIncome: number;
    urbanExtractFileLog: FileLog;
    latestPropertyTaxFileLogId: number;
    cadastreIncomeFileLogId: number;
    cadastralExtractFileLogId: number;
    cadastralPlanFileLogId: number;
    latestPropertyTaxFileLog: FileLog;
    cadastreIncomeFileLog: FileLog;
    cadastralExtractFileLog: FileLog;
    cadastralPlanFileLog: FileLog;
    // Add additional fields or relations here as needed
}